var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 6.81969L14.76 2.78969C13.19 1.68969 10.78 1.74969 9.26997 2.91969L4.25997 6.82969C3.25997 7.60969 2.46997 9.20969 2.46997 10.4697V17.3697C2.46997 19.9197 4.53997 21.9997 7.08997 21.9997H17.87C20.42 21.9997 22.49 19.9297 22.49 17.3797V10.5997C22.49 9.24969 21.62 7.58969 20.52 6.81969ZM13.23 17.9997C13.23 18.4097 12.89 18.7497 12.48 18.7497C12.07 18.7497 11.73 18.4097 11.73 17.9997V14.9997C11.73 14.5897 12.07 14.2497 12.48 14.2497C12.89 14.2497 13.23 14.5897 13.23 14.9997V17.9997Z",
    fill: "#0B1526"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon (4).bee2e8cac15526a24f5dcfb0c54915ea.svg";
export { ForwardRef as ReactComponent };